import '../App.css';
import './Projects.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Websites from './Tabs/Websites';
import Games from './Tabs/Games';


const Projects = () => {
  return (
    <div style={{}}>
      <h1 className='title'>My Projects</h1>
      <div>
        <Tabs style={{width: '90%', margin: 'auto'}}>
          <TabList className='tablist'>
            <Tab selectedClassName='tab-active' className='tab'>Games</Tab>
            <Tab selectedClassName='tab-active'  className='tab'>Websites</Tab>
          </TabList>
          <TabPanel>
            <div className='tabPanel'>
              <Games />
            </div>
          </TabPanel>
          <TabPanel>
            <div className='tabPanel'>
              <Websites />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
  )
}

export default Projects